// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1AoEZ","label":"SetPasswdForm_label__8FMVI"};